
import { reactive, toRefs, Ref, PropType, watchEffect, ref, computed, ComputedRef } from 'vue'
import { Popup, Button } from 'vant'
import { useWindowSizeFn } from '@/hooks/useWindowSizeFn'
import { getRequestLanguage } from '@/api/utils'

/**
 * 具体配置参考:
 * https://qr-code-styling.com/
 * https://github.com/scholtz/qrcode-vue3
 */
// import QRCodeVue3 from 'qrcode-vue3'

interface MDialogState {
  isShowDialog: Ref<boolean>
  vanPopupStyle: Ref<object>
  handleClickBtn: () => void
  handleClose: () => void
  language: Ref<string>
  qrCodeWidth: ComputedRef<number>
}
export default {
  name: 'MDialog',
  components: {
    [Popup.name as string]: Popup,
    [Button.name as string]: Button
  },
  props: {
    show: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: false
    },
    style: {
      type: Object as PropType<object>,
      default: () => {
        const minWidth = window.innerHeight < 500 ? '200px' : '320px'
        const maxWidth = window.innerHeight < 500 ? '200px' : '320px'
        return {
          width: '40%',
          minWidth,
          maxWidth,
          overflow: 'visible'
        }
      }
    },
    headerText: {
      type: String as PropType<string>,
      default: '手机扫码下载weelife App'
    },
    btnText: {
      type: String as PropType<string>,
      default: '下载App'
    },
    qrCodeUrl: {
      type: String as PropType<string>,
      default: window.location.href
    },
    qrCodeLogo: {
      type: String as PropType<string>,
      default: 'logo.png'
    },
    onClose: {
      type: Function as PropType<() => void>,
      required: true
    },
    onDownload: {
      type: Function as PropType<() => void>,
      required: true
    }
  },
  setup(
    props: Readonly<{
      show: boolean
      style: object
      onClose: () => void
      onDownload: () => void
    }>
  ): MDialogState {
    const state = reactive<{
      isShowDialog: boolean
      vanPopupStyle: object
    }>({
      isShowDialog: props.show,
      vanPopupStyle: props.style
    })

    const qrCodeWidth = computed(() => {
      if (window.innerHeight < 500) {
        return 110
      } else {
        return 180
      }
    })

    watchEffect(() => {
      state.isShowDialog = props.show
    })

    watchEffect(() => {
      state.vanPopupStyle = props.style
    })

    const contentWeight = ref(window.innerWidth)

    useWindowSizeFn(
      () => {
        contentWeight.value = window.innerWidth
        if (contentWeight.value <= 320) {
          state.vanPopupStyle = {
            minWidth: '280px'
          } as object
        }
      },
      200,
      { immediate: true }
    )

    const handleClickBtn = () => {
      props.onDownload()
    }

    const handleClose = () => {
      props.onClose()
    }

    const language = computed(() => {
      return getRequestLanguage()
    })

    return {
      ...toRefs(state),
      handleClickBtn,
      handleClose,
      language,
      qrCodeWidth
    }
  }
}
